import { ErrorTypes } from "@wix/form-validator";
import { SupportedDateParts } from "../../utils/date-format-parts.js";
import { deserializeDate } from "../date-picker/helpers.js";
const parseDateTimeValue = (value) => {
  if (!value) {
    return ["", ""];
  }
  const separator = value.indexOf("T") > -1 ? "T" : " ";
  const [date, time] = value.split(separator);
  return [date, time];
};
const formatDateTimeValue = (date, time) => `${date ?? ""}T${time ?? ""}`;
const isIncompleteTime = (time) => {
  if (!time) {
    return true;
  }
  const [hours, minutes] = time.split(":");
  return !hours || !minutes;
};
const getDateTimePartsErrors = (hasError, value) => {
  const [date, time] = parseDateTimeValue(value);
  const { YEAR, MONTH, DAY } = deserializeDate(date);
  const invalidParts = [
    YEAR?.length !== 4,
    !MONTH,
    !DAY,
    isIncompleteTime(time)
  ];
  const allValidParts = !invalidParts.some(Boolean);
  return {
    [SupportedDateParts.YEAR]: hasError && (allValidParts || invalidParts[0]),
    [SupportedDateParts.MONTH]: hasError && (allValidParts || invalidParts[1]),
    [SupportedDateParts.DAY]: hasError && (allValidParts || invalidParts[2]),
    TIME: hasError && (allValidParts || invalidParts[3])
  };
};
const isDateTimeFieldValidationError = (error) => {
  return error?.errorType === ErrorTypes.INCOMPLETE_DATE_ERROR;
};
const getDateTimeValidationErrorSuffix = (error) => isDateTimeFieldValidationError(error) ? error.params.suffix : void 0;
export {
  formatDateTimeValue,
  getDateTimePartsErrors,
  getDateTimeValidationErrorSuffix,
  isIncompleteTime,
  parseDateTimeValue
};
//# sourceMappingURL=date-time-field-utils.js.map
